var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_?\xEB\x8D\x89\xEC\x94\xA0??1",
    clipPath: "url(#clip0_152_378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.7482 11.9471C66.3155 19.8006 61.4639 28.4325 61.4639 28.4325C61.4639 28.4325 52.448 24.3389 49.8705 16.4854C47.3032 8.63183 52.1548 0 52.1548 0C52.1548 0 61.1707 4.09355 63.7482 11.9471Z",
    fill: "#4EB53D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.6301 15.5656C60.7766 18.1329 56.683 27.1589 56.683 27.1589C56.683 27.1589 65.3148 32.0105 73.1684 29.4432C81.0219 26.8759 85.1155 17.8499 85.1155 17.8499C85.1155 17.8499 76.4837 12.9983 68.6301 15.5656Z",
    fill: "#5BC949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M61.1101 25.7338C61.1101 25.7338 67.9226 21.2663 74.7856 20.579",
    stroke: "#16AD00",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.8553 94C64.9713 94 83.7105 77.718 83.7105 57.6331C83.7105 37.5482 64.9713 21.2662 41.8553 21.2662C18.7392 21.2662 0 37.5482 0 57.6331C0 77.718 18.7392 94 41.8553 94Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.0596 19.2144H21.9536V28.8165H61.0596V19.2144Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.2531 24.7028C37.9358 24.7028 42.5426 22.0917 42.5426 18.8707C42.5426 15.6498 37.9358 13.0387 32.2531 13.0387C26.5704 13.0387 21.9637 15.6498 21.9637 18.8707C21.9637 22.0917 26.5704 24.7028 32.2531 24.7028Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.7701 24.7028C56.4528 24.7028 61.0596 22.0917 61.0596 18.8707C61.0596 15.6498 56.4528 13.0387 50.7701 13.0387C45.0874 13.0387 40.4807 15.6498 40.4807 18.8707C40.4807 22.0917 45.0874 24.7028 50.7701 24.7028Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.3082 31.3131C28.9884 31.3131 23.7527 28.483 23.5202 28.3516L24.5208 26.5525C24.5815 26.5828 30.646 29.8273 42.492 29.1703L42.6032 31.2222C41.451 31.2828 40.3593 31.3131 39.3082 31.3131Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.9355 24.4703C39.3789 21.3471 40.8344 17.6073 40.9052 17.4557L42.8155 18.2239C42.8155 18.2239 41.6329 21.2763 42.7751 23.5606L40.9355 24.4804V24.4703Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.6486 52.1447C35.7874 52.1447 36.7105 51.2216 36.7105 50.0828C36.7105 48.944 35.7874 48.0209 34.6486 48.0209C33.5098 48.0209 32.5867 48.944 32.5867 50.0828C32.5867 51.2216 33.5098 52.1447 34.6486 52.1447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M49.0619 52.1447C50.2007 52.1447 51.1239 51.2216 51.1239 50.0828C51.1239 48.944 50.2007 48.0209 49.0619 48.0209C47.9232 48.0209 47 48.944 47 50.0828C47 51.2216 47.9232 52.1447 49.0619 52.1447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M41.9765 58.0172C39.5912 58.0172 37.9032 55.3691 37.8325 55.2579L38.9948 54.5302C39.3688 55.1164 40.6221 56.6527 41.9765 56.6527C42.9064 56.6527 43.8161 55.9351 44.6955 54.5403L45.8578 55.268C44.7157 57.0975 43.4017 58.0274 41.9765 58.0274V58.0172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M62.7779 55.5813C63.3472 55.5813 63.8088 55.1198 63.8088 54.5504C63.8088 53.981 63.3472 53.5194 62.7779 53.5194C62.2085 53.5194 61.7469 53.981 61.7469 54.5504C61.7469 55.1198 62.2085 55.5813 62.7779 55.5813Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M59.6951 59.695C60.2644 59.695 60.726 59.2334 60.726 58.664C60.726 58.0946 60.2644 57.6331 59.6951 57.6331C59.1257 57.6331 58.6641 58.0946 58.6641 58.664C58.6641 59.2334 59.1257 59.695 59.6951 59.695Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.8707 59.695C66.4401 59.695 66.9017 59.2334 66.9017 58.664C66.9017 58.0946 66.4401 57.6331 65.8707 57.6331C65.3014 57.6331 64.8398 58.0946 64.8398 58.664C64.8398 59.2334 65.3014 59.695 65.8707 59.695Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M20.9226 55.5813C21.492 55.5813 21.9535 55.1198 21.9535 54.5504C21.9535 53.981 21.492 53.5194 20.9226 53.5194C20.3532 53.5194 19.8916 53.981 19.8916 54.5504C19.8916 55.1198 20.3532 55.5813 20.9226 55.5813Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M17.8398 59.695C18.4092 59.695 18.8707 59.2334 18.8707 58.664C18.8707 58.0946 18.4092 57.6331 17.8398 57.6331C17.2704 57.6331 16.8088 58.0946 16.8088 58.664C16.8088 59.2334 17.2704 59.695 17.8398 59.695Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M24.0155 59.695C24.5849 59.695 25.0465 59.2334 25.0465 58.664C25.0465 58.0946 24.5849 57.6331 24.0155 57.6331C23.4461 57.6331 22.9845 58.0946 22.9845 58.664C22.9845 59.2334 23.4461 59.695 24.0155 59.695Z",
    fill: "#FF8B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.1155,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage2);
export default __webpack_public_path__ + "static/media/cardImage2.f32bb02a9662942e02ce7a43cc828df3.svg";
export { ForwardRef as ReactComponent };